import { render } from "./Inventory.vue?vue&type=template&id=7339aaa2&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=7339aaa2&lang=scss&scoped=true"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7339aaa2"]])

export default __exports__